import { initLoginContextInfo } from './init-login-context-info';
import { initUserPublicProps } from './init-user-public-props';
import { initAccountPermission } from './init-account-permission';
import { initPrivacyAgreement } from './init-privacy-agreement';
import { initCorpAuthInfo } from './init-corp-auth-info';
import { initUserIdToStaffId } from './init-user-id-to-staff-id';
import { initStaffInfo } from './init-staff-info';
import { initWxUserInfo } from './init-wx-user-info';
import { initStationBgColor } from './init-station-bg-color';
import { initStationThemeConfig } from './init-station-theme-config';
import { initJimoTrackerParams } from './init-jimo-tracker-params';
import { initWebFunnyParams } from './init-web-funny-params';
import { initHiddenShareOption } from './init-hidden-share-option';
import { initUserGroupWxIds } from './init-user-group-wx-ids';
import { initSourceType } from './init-source-type';

interface LayoutServices {
  [key: string]: (() => Promise<void>)[];
}

// 不同 layout 初始化服务
export const LAYOUT_SERVICES: LayoutServices = {
  // 静态 layout
  static: [],
  // 基础 layout
  basic: [
    initLoginContextInfo, // 初始化当前登录信息
    initUserPublicProps, // 初始化当前登录用户公共属性
    initAccountPermission, // 初始化账号权限，可能会跳转无权限页面
    initPrivacyAgreement, // 初始化隐私协议，可能会跳转隐私协议页面
    initCorpAuthInfo, // 初始化企业授权 appId、authCorpId 等参数信息
    initUserIdToStaffId, // 初始化 userId 转换 staffId
    initStaffInfo, // 初始化当前经理信息
    initWxUserInfo, // 初始化微信端用户信息
    initStationBgColor, // 初始化小站背景色配置
    initStationThemeConfig, // 初始化小站主题配置
    initJimoTrackerParams, // 初始化 jimoTracker 大数据埋点参数
    initWebFunnyParams, // 初始化 前端日志 埋点参数
    initHiddenShareOption, // 初始化隐藏分享
    initSourceType, // 初始化页面来源
  ],
  // 活动 layout
  act: [
    initLoginContextInfo, // 初始化当前登录信息
    initUserPublicProps, // 初始化当前登录用户公共属性
    initPrivacyAgreement, // 初始化隐私协议，可能会跳转隐私协议页面
    initCorpAuthInfo, // 初始化企业授权 appId、authCorpId 等参数信息
    initWxUserInfo, // 初始化微信端用户信息
    initJimoTrackerParams, // 初始化 jimoTracker 大数据埋点参数
    initWebFunnyParams, // 初始化 前端日志 埋点参数
    initUserGroupWxIds, // 初始化 用户所在群聊信息
  ],
};
